module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gSSIy"))).then(() => parcelRequire('d0iPb'));